import $http from '@vue-util/http';
import { PersistentLoginUtil } from '@vue-util/persistentLogin';
import { findAndDecode } from '@/utils/DecodeResponse';
import { handleSessionTimeout } from '@/utils/SessionHandler';

export default defineNuxtPlugin(() => {
  $http.interceptors.request.use(
    (request) => {
      // Remove empty query params
      if (request?.params) {
        Object.keys(request.params).forEach((key) => {
          if (!request.params[key]) delete request.params[key];
        });
      }
      // Add persistent login headers
      request.headers = {
        ...PersistentLoginUtil.getDeviceFingerPrintHeaders(),
        ...request.headers,
      };

      // Encode body params
      request.transformRequest = [
        (data) => {
          if (!data) return data;

          if (data.ordertoken) data.ordertoken = encodeURIComponent(data.ordertoken);
          if (data.shipmenttoken) data.shipmenttoken = encodeURIComponent(data.shipmenttoken);
          if (data.pid) data.pid = encodeURIComponent(data.pid);

          return data;
        },
        ...$http.defaults.transformRequest,
      ];
      return request;
    },
    (error) => Promise.reject(error),
  );

  $http.interceptors.response.use(
    (response) => {
      response.data = findAndDecode(response?.data, ['orderToken', 'shipmentToken', 'pendingReturnId', 'pidToken']);
      return response;
    },
    (error) => Promise.reject(error),
  );

  //session handler
  $http.interceptors.response.use(
    (response) => response,
    (error = {}) => {
      let errorCode;
      const { data } = error.response || { data: { errors: { error: [] } } };
      if (data?.errorCode) {
        errorCode = data.errorCode;
      } else {
        errorCode = data?.errors?.error?.[0]?.errorCode;
      }
      handleSessionTimeout(errorCode);
      return Promise.reject(error);
    },
  );
});
